import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=67a4efb7&"
import script from "./LocationForm.vue?vue&type=script&lang=ts&"
export * from "./LocationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports